// Per-environment MFA policy for the admin/dev features. Must agree with the
// backend's privilegedMfa config in bin/cdk.ts and the pool's MFA settings.
// Fail closed: MFA is required unless REACT_APP_MFA_REQUIRED is explicitly
// "false" (staging).
export const MFA_REQUIRED = process.env.REACT_APP_MFA_REQUIRED !== "false"
